// @ts-nocheck
/* eslint-disable no-useless-escape */
import React, { Component } from 'react';
import axios from 'axios';
import { inject, observer } from "../../../stores/mobx-compat";

import Modal, { ModalActions } from '../../ui/Modal';
import FormGroup from '../../ui/FormGroup';
import Input from '../../ui/Input';
import Textarea from '../../ui/Textarea';
import { MailIcon } from '../../ui/icons';
import { API_URL } from '../../../configs';

const EMAIL_RE = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class ShareModal extends Component {
  state = {
    to: this.props.sendToSelf ? this.props.store.auth.user.email : '',
    subject: 'Movology Setup Instructions',
    emailBody: '',
    loading: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.sendToSelf !== this.props.sendToSelf) {
      this.setState({ to: this.props.sendToSelf ? this.props.store.auth.user.email : '' });
    }
  }

  set = (name, value) => this.setState({ [name]: value });

  send = async () => {
    let { to, subject, emailBody } = this.state;
    to = to.trim(); subject = subject.trim(); emailBody = emailBody.trim();

    if (!EMAIL_RE.test(String(to).toLowerCase())) {
      this.props.store.failure('Please format the email correctly.');
      return;
    }
    if (to === '' || subject === '' || emailBody === '') {
      this.props.store.failure('All fields are required.');
      return;
    }
    await this.actuallySend({ to, subject, emailBody });
  }

  actuallySend = async ({ to, subject, emailBody }) => {
    try {
      this.setState({ loading: true });
      const res = await axios.post(`${API_URL}/api/um/setup-email`, { to, subject, emailBody });
      if (res.data.success) {
        this.props.store.success('Email sent successfully!');
        this.setState({ to: '', subject: '', emailBody: '' });
        this.props.onClose();
      } else {
        this.props.store.failure('Email was not sent for some reason.');
      }
    } catch (e) {
      this.props.store.failure('Email was not sent for some reason.');
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        size="md"
        title="Share setup instructions"
        icon={MailIcon}
        closeOnScrim={false}
        actions={(
          <ModalActions
            onCancel={this.props.onClose}
            onConfirm={this.send}
            confirmLabel="Send"
            confirmLoading={this.state.loading}
          />
        )}
      >
        <FormGroup label="To">
          <Input
            placeholder="tech@company.com"
            value={this.state.to}
            onChange={(e) => this.set('to', e.target.value)}
          />
        </FormGroup>
        <FormGroup label="Subject">
          <Input
            value={this.state.subject}
            onChange={(e) => this.set('subject', e.target.value)}
          />
        </FormGroup>
        <FormGroup label="Body">
          <Textarea
            placeholder="Just provide the context, we'll attach the instructions!"
            value={this.state.emailBody}
            onChange={(e) => this.set('emailBody', e.target.value)}
          />
        </FormGroup>
      </Modal>
    );
  }
}

export default inject('store')(observer(ShareModal));
